import React from 'react'
import PropTypes from 'prop-types'
import { useConnect } from 'sb-redux-hook'
import { getAddress, links } from 'common/helpers'

import Box from 'components/_new/layout/Box/Box'
import Title from 'components/_new/typography/deprecated/Title/Title'
import Card from 'components/_new/layout/Card/Card'
import Text from 'components/_new/typography/Text/Text'
import Button from 'components/_new/Button/Button'
import Grid from 'components/_new/layout/grid/Grid/Grid'

import messages from './messages'


const AddressReview = ({ onClick }) => {
  const { shippingAddress } = useConnect({
    shippingAddress: (state) => {
      const { models: { me: { shipping } } } = state

      return getAddress(shipping)
    },
  })

  return (
    <Box alignLeft mt="36">
      <Title message={messages.title} size="sm" />
      <Grid columns={{ mobile: 1, exceptMobile: 2 }} gutter="16">
        <Card size="md" withBg>
          <Text message={messages.currentlyShipping} size="14-24" />
          <Box mt="8" mb="8">
            <Text semibold size="14-24" message={shippingAddress} />
          </Box>
          <Box alignCenter mt="24">
            <Button
              size="sm"
              color="brandTransparent"
              fullWidth
              title={messages.update}
              to={`${links.profile.billingAndShipping}#shipping`}
              onClick={onClick}
            />
          </Box>
        </Card>
      </Grid>
    </Box>
  )
}

AddressReview.propTypes = {
  onClick: PropTypes.func.isRequired,
}


export default AddressReview
